module.exports = __webpack_public_path__ + "img/button-service-catalogue.49965422.png";